<template>
  <div class="flex items-center gap-3 py-2">
    <p class="title">{{ label }}</p>
    <vs-select autocomplete v-model="selectData.selectType" class="flex-1">
      <vs-select-item text="전체" value="전체" />
      <vs-select-item v-for="option in options" :key="option" :text="option" :value="option" />
    </vs-select>
    <div class="select-buttons">
      <button :class="selectData.buttonInput === '이행' && 'action'" @click="selectData.buttonInput = '이행'">이행</button>
      <button :class="selectData.buttonInput === '미이행' && 'action'" @click="selectData.buttonInput = '미이행'">미이행</button>
    </div>
    <button class="trash-button" @click="$emit('delete')"><feather-icon icon="Trash2Icon" style="width: 20px; height: 20px; color: #7e72f2" class="align-bottom" /></button>
  </div>
</template>

<script>
export default {
  props: {
    isReadonly: Boolean,
    label: { type: String, default: "필터" },
    options: {
      type: Array,
      default: () => [],
    },
    value: Object,
  },
  data() {
    return {
      selectData: this.value,
    };
  },
  watch: {
    value: {
      handler(value) {
        this.selectData = value;
      },
    },
    selectData: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  width: 48px;
  font-size: 14px;
  font-weight: 500;
}

.select-buttons {
  flex: 1;
  & > button {
    width: 50%;
    height: 38px;

    font-size: 14px;
    font-weight: 400;

    background: white;
    border: solid 1px #cdcdcd;
    cursor: pointer;

    &:first-child {
      border-right: none;
      border-radius: 5px 0px 0px 5px;
      &.action {
        color: #fff;
        background: #28c76f;
      }
    }
    &:last-child {
      border-radius: 0px 5px 5px 0px;
      &.action {
        color: #fff;
        background: #ea5455;
      }
    }
  }
}

.trash-button {
  width: 36px;
  height: 38px;
  background: none;
  border: none;
  cursor: pointer;
}
</style>
